import React, { useId } from "react";
import {
  PREMIUM_PANEL_OUTER,
  PREMIUM_PANEL_INNER,
  PREMIUM_OUTER,
  PREMIUM_INNER,
  PREMIUM_ENGRAVING,
  CLASSIC_CORNER_CAP,
} from "../constants/scoreboardMaterials";
import "./ScoreboardFrame.css";

// Independent edges and square corner caps: no stretched/cropped table image.
export default function ScoreboardFrame({ variant, detail = "outer" }) {
  const id = useId().replace(/:/g, "");
  if (variant !== "classic-green" && variant !== "premium") return null;
  const premium = variant === "premium";
  const panel = detail === "panel";
  return (
    <div
      className={`sb-frame sb-frame--${variant} sb-frame--${detail}`}
      aria-hidden="true"
    >
      {["top", "right", "bottom", "left"].map((side) => (
        <i key={side} className={`sb-frame-rail sb-frame-rail--${side}`} />
      ))}
      {["top-left", "top-right", "bottom-right", "bottom-left"].map(
        (corner) => (
          <i
            key={corner}
            className={`sb-frame-corner sb-frame-corner--${corner}`}
          >
            <svg
              width="100%"
              height="100%"
              viewBox={panel ? "0 0 32 32" : "0 0 48 48"}
            >
              {premium ? (
                <g fill="none">
                  <path
                    d={panel ? PREMIUM_PANEL_OUTER : PREMIUM_OUTER}
                    stroke="#c49136"
                    strokeWidth="1.1"
                  />
                  <path
                    d={panel ? PREMIUM_PANEL_INNER : PREMIUM_INNER}
                    stroke="#e9bd63"
                    strokeWidth=".7"
                  />
                  {!panel && (
                    <path
                      d={PREMIUM_ENGRAVING}
                      stroke="#b78734"
                      strokeWidth=".65"
                    />
                  )}
                </g>
              ) : (
                <>
                  <defs>
                    <linearGradient id={id + "brass" + corner} x2="1" y2="1">
                      <stop offset="0" stopColor="#fbe487" />
                      <stop offset=".3" stopColor="#c99428" />
                      <stop offset=".65" stopColor="#805019" />
                      <stop offset="1" stopColor="#eec756" />
                    </linearGradient>
                    <radialGradient
                      id={id + "pocket" + corner}
                      cx="60%"
                      cy="60%"
                    >
                      <stop offset="0" stopColor="#00451d" />
                      <stop offset="1" stopColor="#001c0b" />
                    </radialGradient>
                  </defs>
                  <path
                    d={CLASSIC_CORNER_CAP}
                    fill={`url(#${id}brass${corner})`}
                  />
                  <path
                    d="M46 2H19C9 2 2 9 2 19V46"
                    fill="none"
                    stroke="#f6db79"
                    strokeWidth="1.2"
                  />
                  <circle
                    cx="25"
                    cy="25"
                    r="13"
                    fill={`url(#${id}pocket${corner})`}
                    stroke="#bd8c2f"
                    strokeWidth="2"
                  />
                  <path
                    d="M15 28A11 11 0 0 1 29 15"
                    fill="none"
                    stroke="#ffe692"
                    strokeWidth="2"
                  />
                  <path
                    d="M36 24A12 12 0 0 1 24 36"
                    fill="none"
                    stroke="#023714"
                    strokeWidth="2"
                  />
                </>
              )}
            </svg>
          </i>
        )
      )}
    </div>
  );
}
